import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ItnFundedMechanism = ({ itnFundedMechanism, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="itnFundedMechanism" className="planField">
            <GroupApprovers />
            <FormControl required={required.includes("itnFundedMechanism")}>
                <FormLabel className="planRadioTitle">
                    {xplanLabels.itnFundedMechanism}
                </FormLabel>
                <RadioGroup
                    name="itnFundedMechanism"
                    label={xplanLabels.itnFundedMechanism}
                    value={itnFundedMechanism}
                    onChange={(e) => handleChange("itnFundedMechanism", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Subaward"
                        control={<Radio disabled={!canEdit} />}
                        label="Subaward"
                    />
                    <FormControlLabel
                        value="Vendor"
                        control={<Radio disabled={!canEdit} />}
                        label="Vendor"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"itnFundedMechanism"} />}
        </div>
    );
};

export default ItnFundedMechanism;